<ng-template #contentHeaderTemplate></ng-template>

<app-table
  id="dashboard.inquiries.index"
  routerLinkPrefix="/patients/"
  routerLinkValue="patient_id"
></app-table>
